import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MasterService } from 'app/services/master/master.service';
import { FormBaseComponent } from 'app/components/form/form-base.component';
import { MstNotificationModel } from 'app/model/mst.notification.model';


@Component({
    selector: 'form-notification',
    templateUrl: './form-notification.component.html',
    styleUrls: ['./form-notification.component.scss']
})
export class FormNotificationComponent extends FormBaseComponent implements OnInit {

    /** 日付入力設定 */
    datepickerOpts: object;
    dataPipe: DatePipe;

    notifications: Array<
        MstNotificationModel & {
            dateObj?: Date,
            changed?: boolean, 
            validContent?: boolean,
            validLink?: boolean,
            validDate?: boolean
        }>;
    
    validAll : boolean;

    /** 入力モード */
    confirmation: boolean;

    constructor(private masterService: MasterService) { 
        super();
        this.dataPipe = new DatePipe('en-US');
        this.datepickerOpts = {
            startDate: null,
            autoclose: true,
            endDate: new Date(),
            todayBtn: 'linked',
            todayHighlight: true,
            assumeNearbyYear: true,
            format: 'yyyy/mm/dd',
            language: 'ja',
            placeholder: '日付入力',
            preicon: 'fa fa-calendar',
            feedbackText: '日付入力を入力してください'
        }
    }

    /**
     * 初期処理
     */
    async ngOnInit() {

        try {
            this.loading.emit(true);
            this.confirmation = false;
            this.notifications = await this.masterService.getNotifications();
            this.notifications.forEach(item => {
                item.dateObj = item.date && item.date.length > 0 ? new Date(item.date + ' GMT+0900') : null;
                item.changed = false;
                item.validContent = false;
                item.validLink = false;
                item.validDate = false;
            })
            this.validAll = false;

        } catch(err) {
            this.alert('danger', err.message);
        } finally {
            this.loading.emit(false);
        }
    }

    /**
     * 新規行追加
     */
    addRow() {
        this.notifications.push(
            Object.assign(
                new MstNotificationModel(), 
                {
                    changed: false,
                    del:false
                }));
    }


    /**
     * 入力チェック処理
     */
    validateForm(form) {
        if (form.invalid)  {
            this.validAll = true;
            return;
        }

        for (let item of this.notifications) {
            if ((!item.id && !item.del) || (item.id && item.del) || (item.id && item.changed)) {
                this.confirmation = true;
                return;
            }
        }
    }

    /**
     * 入力内容を更新する
     */
    async updateForm() {

        try {
            this.loading.emit(true);

            let updateList: MstNotificationModel[] = [];

            this.notifications.forEach(item => {

                if ((!item.id && !item.del) || (item.id && item.del) || (item.id && item.changed)) {
                    item.date = this.dataPipe.transform(item.dateObj, 'yyyy/MM/dd');
                    updateList.push(Object.assign({}, item));
                }
            });
            await this.masterService.updateNotifications(updateList);
            
            this.alert('success', 'お知らせ情報を更新しました。', 7000);

            await this.ngOnInit();

        } catch(err) {
            this.alert('danger', err.message);
            this.confirmation = true;
            console.error(err);

        } finally {
            this.loading.emit(false);
        }


    }

    trackByIndex(index: number, value: number) {
        return index;
    }
}



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/components/form-setting/form-notification.component.ts